/**
 * created by tian ruo jun
 * 采访任务统计
 */
import React, {Component} from 'react';
import {Tabs, Pagination, message} from 'antd';
import MyTable from "../component/MyTable";
import BseTitle from "../../components/bseTitle/BseTitle";
import {HEADER_HEIGHT} from '../../../constants'
import '../component/style/MyTable.css'
import {getInterviewTaskCreateResult, getInterviewTaskAcceptResult} from '../../../actions/taskStatistical';
import {applicationName} from "../../../utils";

const {TabPane} = Tabs;

export default class TaskStatistical extends Component {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            tabKey: '1',

            count1: {
                '按创建任务数排序': 'taskCount',
                '按已完成数排序': 'completedCount',
                '按未完成数排序': 'unfinishedCount',
            }, // 排序规则1

            count2: {
                '按接收任务数排序': 'taskCount',
                '按已完成数排序': 'completedCount',
                '按未完成数排序': 'unfinishedCount',
            }, // 排序规则2

            // 按单位搜索数据
            params1: {
                a: 1,
                start: 1,
                size: 10,
                startDate: '',
                endDate: '',
                queryStr: '',
                orderCondition: 'taskCount',
            },

            // 按个人搜索数据
            params2: {
                a: 2,
                start: 1,
                size: 10,
                startDate: '',
                endDate: '',
                queryStr: '',
                orderCondition: 'taskCount',
            },

            // 按单位获取到的数据
            data1: {
                dataSource: [], // 表数据
                total: 0,// 数据总条数
            },

            // 按个人获取到的数据
            data2: {
                dataSource: [], // 表数据
                total: 0,// 数据总条数
            },

            // 按单位表格表头
            columns1: [
                {
                    title: '姓名',
                    dataIndex: 'name',
                    key: 'name',
                    align: 'center',
                    ellipsis: true,
                },
                {
                    title: '创建任务',
                    dataIndex: 'taskCount',
                    key: 'taskCount',
                    align: 'center',
                    render: (value) => {
                        return value || 0
                    }
                },
                {
                    title: '已完成',
                    dataIndex: 'completedCount',
                    key: 'completedCount',
                    align: 'center',
                    render: (value) => {
                        return value || 0
                    }
                },
                {
                    title: '未完成',
                    dataIndex: 'unfinishedCount',
                    key: 'unfinishedCount',
                    align: 'center',
                    render: (value) => {
                        return value || 0
                    }
                }
            ],

            // 按单位表格表头
            columns2: [
                {
                    title: '姓名',
                    dataIndex: 'name',
                    key: 'name',
                    align: 'center',
                    ellipsis: true,
                },
                {
                    title: '任务',
                    dataIndex: 'taskCount',
                    key: 'taskCount',
                    align: 'center',
                    render: (value) => {
                        return value || 0
                    }
                },
                {
                    title: '已完成',
                    dataIndex: 'completedCount',
                    key: 'completedCount',
                    align: 'center',
                    render: (value) => {
                        return value || 0
                    }
                },
                {
                    title: '未完成',
                    dataIndex: 'unfinishedCount',
                    key: 'unfinishedCount',
                    align: 'center',
                    render: (value) => {
                        return value || 0
                    }
                },
            ],
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
        // this.getDataStatus()
    }

    // 获取表格数据
    getDataStatus = () => {
        if (this.state.tabKey === '1') {
            getInterviewTaskCreateResult(this.state.params1, (res) => {
                if (res) {
                    this.state.data1.total = res.count;
                    if (res.data) {
                        this.state.data1.dataSource = res.data;
                    }
                    this.setState({})
                }
            })
        } else {
            getInterviewTaskAcceptResult(this.state.params2, (res) => {
                if (res) {
                    this.state.data2.total = res.count;
                    if (res.data) {
                        this.state.data2.dataSource = res.data;
                    }
                    this.setState({})
                }
            })
        }
    };

    // tab栏切换
    tabChange = (key) => {
        this.state.tabKey = key;
        this.setState({});
        // this.getDataStatus();
    };

    // 选择排序方式
    mySelect = (count) => {
        if (this.state.tabKey === '1') {
            this.state.params1.orderCondition = this.state.count1[count];
            this.state.params1.start = 1;
            this.state.params1.size = 10;
        } else {
            this.state.params2.orderCondition = this.state.count2[count];
            this.state.params2.start = 1;
            this.state.params2.size = 10;
        }
        this.setState({}, () => {
            this.getDataStatus()
        })
    };

    // 搜索功能
    mySearch = (query) => {
      if(this.state.tabKey === '1') {
        this.state.params1.queryStr = query.trim();
        this.state.params1.start = 1;
        this.state.params1.size = 10;
      } else {
        this.state.params2.queryStr = query.trim();
        this.state.params2.start = 1;
        this.state.params2.size = 10;
      }
      this.setState({},()=>{
        this.getDataStatus()
      })
    };

    // 导出功能
    myExport = () => {
        if (this.state.tabKey === '1') {
            if(!this.state.data1.total) return message.error('数据表为空，无法导出！');
            let params1 = this.state.params1;
            //getExport(params1)
            //window.open("/cm-sites-" + applicationName() + '/exceptResult/exportNewsClueDeptResult'+'?queryStr='+params1.queryStr+'&startDate='+params1.startDate+'&endDate='+params1.endDate+'&orderCondition='+params1.orderCondition)
            window.location.href = "/cm-sites-" + applicationName() + '/exceptResult/exportInterviewTaskCreateResult' + '?queryStr=' + params1.queryStr + '&startDate=' + params1.startDate + '&endDate=' + params1.endDate + '&orderCondition=' + params1.orderCondition;
        } else {
            if(!this.state.data2.total) return message.error('数据表为空，无法导出！');
            let params2 = this.state.params2;
            window.location.href = "/cm-sites-" + applicationName() + '/exceptResult/exportInterviewAcceptResult' + '?queryStr=' + params2.queryStr + '&startDate=' + params2.startDate + '&endDate=' + params2.endDate + '&orderCondition=' + params2.orderCondition;
        }
    };

    // 日期选择
    datetime = (start, end) => {
        if (this.state.tabKey === '1') {
            this.state.params1.startDate = start;
            this.state.params1.endDate = end;
            this.state.params1.start = 1;
            this.state.params1.size = 10;
        } else {
            this.state.params2.startDate = start;
            this.state.params2.endDate = end;
            this.state.params2.start = 1;
            this.state.params2.size = 10;
        }
        this.setState({}, () => {
            this.getDataStatus()
        })
    };

    // 页码及size改变
    pageChange = (start, size) => {
        if (this.state.tabKey === '1') {
            this.state.params1.start = start;
            this.state.params1.size = size;
        } else {
            this.state.params2.start = start;
            this.state.params2.size = size;
        }
        this.setState({}, () => {
            this.getDataStatus()
        })
    };

    render() {
        let {tabKey, params1, params2, data1, data2, count1, count2, columns1, columns2} = this.state;

        let mySelectOptions1 = [];
        for (let i in count1) {
            mySelectOptions1.push(i);
        }
        let mySelectOptions2 = [];
        for (let i in count2) {
            mySelectOptions2.push(i);
        }

        let height = window.innerHeight - HEADER_HEIGHT;
        let tableHeight = height - 10 - 40 - 36 - 32 - 100;

        let props = {
            tabKey,
            tableHeight,
            datetimeList: ['本周', '上周', '本月', '上月'],
            mySelect: this.mySelect,
            myExport: this.myExport,
            datetime: this.datetime,
            mySearch: this.mySearch,
            placeholder: '请输入姓名',
        };
        let props1 = {
          ...props,
          columns: columns1,
          dataSource: data1.dataSource,
          mySelectOptions: mySelectOptions1,
        };
        let props2 = {
          ...props,
          columns: columns2,
          dataSource: data2.dataSource,
          mySelectOptions: mySelectOptions2,
        };

        return (
            <div style={{height: height, background: '#fff'}}>
                {/*<BseTitle title={'采访任务统计'}/>*/}
                <div style={{height:10}}></div>
                <div className={'tabBox'} style={{height: height - 10 - 32 - 100}}>
                    <Tabs defaultActiveKey="1" type="card"
                          tabBarStyle={{margin: 18}}
                          tabBarGutter={0}
                          onChange={this.tabChange}
                    >
                        {/*任务下发*/}
                        <TabPane tab="任务下发" key="1">
                            <div style={{height: tableHeight}}>
                                <MyTable {...props1} />
                            </div>
                        </TabPane>
                        {/*任务认领*/}
                        <TabPane tab="任务认领" key="2">
                            <div style={{height: ''}}>
                                <MyTable {...props2} />
                            </div>
                        </TabPane>
                    </Tabs>
                </div>
                {/*高32，上下边距50*/}
                <div style={{display: "flex", justifyContent: "space-between", margin: '50px 20px'}}>
                    <div>共搜索到 {tabKey === '1' ? data1.total : data2.total} 条数据</div>
                    <Pagination
                        showQuickJumper
                        showSizeChanger
                        defaultCurrent={1}
                        defaultPageSize={10}
                        current={tabKey === '1' ? params1.start : params2.start}
                        pageSize={tabKey === '1' ? params1.size : params2.size}
                        total={tabKey === '1' ? data1.total : data2.total}
                        onChange={this.pageChange} //页码改变时回调
                        onShowSizeChange={this.pageChange} //每页条数改变回调
                    />
                </div>
            </div>
        )
    }

}